import { Theme } from '@radix-ui/themes';
import { ErrorBoundary as RollbarErrorBoundary, Provider as RollbarProvider } from '@rollbar/react';
import { store } from 'app/store';
import { PageTopBarProvider } from 'components/PageTopBar/page-top-bar.context';
import { ThemeProvider } from 'components/Theme/theme-provider';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Toaster } from 'sonner';
import { rollbarConfig } from './rollbarConfig';
import './i18n';
import App from './router/app';

import './index.css';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import posthog from './posthog';
import { PostHogProvider } from '@posthog/react';
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(duration);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Theme>
      <Provider store={store}>
        <RollbarProvider config={rollbarConfig}>
          <RollbarErrorBoundary
            fallbackUI={(error) => (
              <div>
                <b>Something went wrong. We&apos;re very sorry. Please try again.</b>
                <br />
                <i>Error: {error.error?.message}</i>
              </div>
            )}
          >
            <ThemeProvider defaultTheme="light" storageKey="manager-ui-theme">
              <PageTopBarProvider initialStringTitle="">
                <PostHogProvider client={posthog}>
                  <App />
                </PostHogProvider>
              </PageTopBarProvider>
            </ThemeProvider>
            <Toaster
              richColors
              closeButton
              toastOptions={{
                style: {
                  zIndex: 100000,
                },
                className: 'my-toast',
              }}
              position="bottom-center"
              expand={true}
            />
          </RollbarErrorBoundary>
        </RollbarProvider>
      </Provider>
      {/* <ThemePanel /> */}
    </Theme>
  </StrictMode>,
);
